import { render, staticRenderFns } from "./mediaPlatformTag.vue?vue&type=template&id=c4feeacc&scoped=true&"
import script from "./mediaPlatformTag.vue?vue&type=script&lang=js&"
export * from "./mediaPlatformTag.vue?vue&type=script&lang=js&"
import style0 from "./mediaPlatformTag.vue?vue&type=style&index=0&id=c4feeacc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4feeacc",
  null
  
)

component.options.__file = "mediaPlatformTag.vue"
export default component.exports